// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IpKy","buttons":"styles_buttons__1BJUt"};